export default "__VITE_ASSET__BoYdZeSX__"